var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2361 3.63886C14.5046 3.90735 14.5046 4.34265 14.2361 4.61114L7.84727 11L14.2361 17.3889C14.5046 17.6574 14.5046 18.0927 14.2361 18.3611C13.9676 18.6296 13.5323 18.6296 13.2639 18.3611L6.38886 11.4861C6.12038 11.2177 6.12038 10.7823 6.38886 10.5139L13.2639 3.63886C13.5323 3.37038 13.9677 3.37038 14.2361 3.63886Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.2633b13bbb667455a10a0f3225c0557f.svg";
export { ForwardRef as ReactComponent };